import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { getSessionItem } from '../utils/sessionStorage'

export default function useModalManager (isVisible?: boolean): { email: string | null } {
  const [email, setEmail] = useState<string | null>('')
  const navigate = useNavigate()
  useEffect(() => {
    const email = getSessionItem('email')
    if (!email) {
      navigate('/')
    } else {
      setEmail(email)
    }
  }, [])

  return { email }
};
